// import Img1 from "./../../../public/assets/images/vedio_youtube/1.jpeg";
// import Img2 from "./../../../public/assets/images/vedio_youtube/2.jpeg";

import VideoCard from "./components/VideoCard";
import Data from "../../data/vedio_youtube.json";

function VideoYoutube() {
  return (
    <section className="mentor video-youtube my-5" id="videoYoutube">
      <div className="container my-5">
        <h2 className="text-center font-weight-bold" style={{ fontSize: '50px', fontFamily: "'DM Serif Display', serif" }}><b>Students Reviews</b></h2>
        <p className="text-center" >
          How it has helped candidates to accelerate their careers in full stack development to the next level.
        </p>
        {/* <p className="text-center">
          Discover the impact of our programs on career growth
        </p> */}
        <div className="review_scroll_sec">
          {/* <div className="review_scroll_inner"> */}
          {Data.map((data) => (
            <div className="review_scroll_inner" key={data.id}>
              {data.items.map((item) => (
                <VideoCard key={item.id} {...item} />
              ))}
            </div>
          ))}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
}
export default VideoYoutube;
